import React from 'react';

import { MenuItem, TextField } from '@mui/material';

export interface FieldOption {
  label: string;
  value: string;
}

export interface ReadOnlyFieldConfig {
  helperText?: string;
  label: string;
  multiline?: boolean;
  options?: Array<FieldOption>;
  readOnly?: boolean;
  value: string;
}

interface Props {
  field: ReadOnlyFieldConfig;
}

export default function ReadOnlyField({ field }: Props) {
  const isReadOnly = field.readOnly ?? true;

  if (field.options) {
    return (
      <TextField
        disabled
        fullWidth
        select
        helperText={field.helperText}
        label={field.label}
        size="small"
        value={field.value}
      >
        {!field.value && <MenuItem value="">Not available</MenuItem>}
        {field.options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
    );
  }

  return (
    <TextField
      fullWidth
      helperText={field.helperText}
      label={field.label}
      minRows={field.multiline ? 3 : undefined}
      multiline={field.multiline}
      size="small"
      value={field.value}
      slotProps={{
        htmlInput: { 'aria-readonly': isReadOnly },
        input: { readOnly: isReadOnly },
      }}
    />
  );
}
